module.exports = __webpack_public_path__ + "static/media/10.ea30d012.png";